import React from "react";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import PublicNav from "../components/PublicNav";
import { Mail } from "lucide-react";

const TelegramIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/></svg>
);
const InstagramIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
);
const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M16.6 5.82a4.28 4.28 0 01-1.06-2.82h-3.2v12.9a2.6 2.6 0 11-2.6-2.6c.27 0 .53.04.78.12V7.16a5.85 5.85 0 00-.78-.05 5.82 5.82 0 105.82 5.82V8.9a7.44 7.44 0 004.35 1.4V7.1a4.28 4.28 0 01-3.31-1.28z"/></svg>
);

const CHANNELS = [
  { label: "Telegram", value: "@poolefx", href: "https://t.me/poolefx", Icon: TelegramIcon, color: "text-sky-400", bg: "hover:border-sky-400/50", testid: "contact-telegram" },
  { label: "Instagram", value: "@raeinexchange", href: "https://www.instagram.com/raeinexchange", Icon: InstagramIcon, color: "text-pink-400", bg: "hover:border-pink-400/50", testid: "contact-instagram" },
  { label: "TikTok", value: "@raeinexchange", href: "https://www.tiktok.com/@raeinexchange", Icon: TikTokIcon, color: "text-white", bg: "hover:border-white/50", testid: "contact-tiktok" },
  { label: "Email", value: "inforaeinex@gmail.com", href: "mailto:inforaeinex@gmail.com", Icon: Mail, color: "text-emerald-400", bg: "hover:border-emerald-400/50", testid: "contact-email" },
];

export default function Contact() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {user ? <Navbar /> : <PublicNav />}
      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="contact-page">
        <span className="inline-flex items-center gap-2 text-xs font-mono px-3 py-1 rounded-full bg-purple-500/15 text-purple-400 border border-purple-500/20 mb-6">
          CONTATTI
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05] mb-4">Restiamo in contatto</h1>
        <p className="text-lg text-zinc-400 mb-12">Seguimi sui canali ufficiali o scrivimi direttamente.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CHANNELS.map(({ label, value, href, Icon, color, bg, testid }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}
              className={`flex items-center gap-4 p-5 rounded-md bg-[#141414] border border-white/10 ${bg} transition-colors group`}>
              <span className={`${color}`}><Icon width={26} height={26} /></span>
              <div>
                <div className="text-sm font-semibold text-white">{label}</div>
                <div className="text-sm text-zinc-400 group-hover:text-zinc-200 transition-colors">{value}</div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 p-6 rounded-md bg-[#141414] border border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <div className="text-lg font-semibold text-white">Preferisci scrivere direttamente?</div>
            <div className="text-sm text-zinc-400">Scrivimi su Telegram, ti rispondo il prima possibile.</div>
          </div>
          <a
            href="https://t.me/poolefx"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-telegram-support-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-sky-500 text-white font-medium hover:bg-sky-400 transition-colors whitespace-nowrap"
          >
            <TelegramIcon width={18} height={18} /> Scrivimi su Telegram
          </a>
        </div>
      </main>
    </div>
  );
}
